import React from 'react'
import {NavLink, useLocation} from 'react-router-dom';
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import MobileFriendlyOutlinedIcon from '@material-ui/icons/MobileFriendlyOutlined';
import AppDrawer from "@material-ui/core/Drawer/Drawer";
import {makeStyles} from "@material-ui/core";
import {drawerWidth} from "../config/consts";
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import DashboardIcon from '@material-ui/icons/Dashboard';

export default function Drawer({open, setOpen}) {


    const handleDrawerClose = () => {
        setOpen(false);
    };

    const location = useLocation();

    const routeIsActive = (path) => location.pathname.includes(path);

    const classes = useStyles();

    return (
        <AppDrawer
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}

            classes={{
                paper: clsx({
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}
        >
            <div className={classes.toolbar}>
                <IconButton onClick={handleDrawerClose}>
                    <ChevronRightIcon/>
                </IconButton>
            </div>
            <Divider/>
            <List>
                {menuItems.map(({name, icon, path}) => (
                    <NavLink key={name} to={path} style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItem button key={name} selected={routeIsActive(path)}>
                            <ListItemIcon>{icon}</ListItemIcon>
                            <ListItemText primary={name}/>
                        </ListItem>
                    </NavLink>
                ))}
            </List>
        </AppDrawer>
    )
}


const menuItems = [
    {
        name: 'داشبورد',
        icon: <DashboardIcon fontSize="large"/>,
        path: '/dashboard'
    }, {
        name: 'کاربران',
        icon: <AccountBoxIcon fontSize="large"/>,
        path: '/users'
    },
    {
        name: 'محصولات',
        icon: <MobileFriendlyOutlinedIcon fontSize="large"/>,
        path: '/devices'
    }];


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        backgroundColor: theme.palette.dark.light,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        backgroundColor: theme.palette.dark.light,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    }
}));
